import { z } from "zod";
import { badgeTierValues } from "../constant_values";
export const BadgeTierSchema = z.enum(badgeTierValues);
export const badgeProgression = [
    {
        id: "normie",
        badgeTier: "Normie",
        minBlocks: 1,
        maxBlocks: 249,
        thresholdLabel: "1 Block",
        achievementBadgeId: "normie-badge",
        achievementBadgeName: "Normie Badge",
    },
    {
        id: "builder",
        badgeTier: "Builder",
        minBlocks: 250,
        maxBlocks: 499,
        thresholdLabel: "250 Blocks",
        achievementBadgeId: "builder-badge",
        achievementBadgeName: "Builder Badge",
    },
    {
        id: "architect",
        badgeTier: "Architect",
        minBlocks: 500,
        maxBlocks: 749,
        thresholdLabel: "500 Blocks",
        achievementBadgeId: "architect-badge",
        achievementBadgeName: "Architect Badge",
    },
    {
        id: "og",
        badgeTier: "OG",
        minBlocks: 750,
        maxBlocks: 999,
        thresholdLabel: "750 Blocks",
        achievementBadgeId: "og-badge",
        achievementBadgeName: "OG Badge",
    },
    {
        id: "ambassador",
        badgeTier: "Ambassador",
        minBlocks: 1000,
        maxBlocks: null,
        thresholdLabel: "1,000 Blocks",
        achievementBadgeId: "ambassador-badge",
        achievementBadgeName: "Ambassador Badge",
    },
];
const badgeProgressionByTier = new Map(badgeProgression.map((step) => [step.badgeTier, step]));
export function getBadgeProgressionStepForTier(tier) {
    return badgeProgressionByTier.get(tier) ?? null;
}
export function getBadgeProgressionStepForBlocks(blocks) {
    const safeBlocks = Math.max(0, Number(blocks ?? 0));
    for (let index = badgeProgression.length - 1; index >= 0; index -= 1) {
        const step = badgeProgression[index];
        if (safeBlocks >= step.minBlocks) {
            return step;
        }
    }
    return null;
}
export function getBadgeTierForBlocks(blocks) {
    return getBadgeProgressionStepForBlocks(blocks)?.badgeTier ?? null;
}
